import Dashboard from './Dashboard/Dashboard'
import ModalNewRequest from './ModalNewRequest/ModalNewRequest'
import Solicitudes from './Solicitudes/Solicitudes'
import FormManager from './FormManager/FormManager'
import Reporting from './Reporting/Reporting'

export const DashboardPage = Dashboard
export const ModalNewRequestPage = ModalNewRequest
export const SolicitudesPage = Solicitudes
export const FormManagerPage = FormManager
export const ReportingPage = Reporting

